export default __webpack_public_path__ + "static/media/768-512-16645607-thumbnail-3x2-narmada.b7676ed5.jpg";